import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, } from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { routes } from "./app.routes";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { tokenInterceptor } from "./core/interceptors/token.interceptor";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { ProfileStoreModule } from "./core/store/profile";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { errorInterceptor } from "./core/interceptors/error.interceptor";
import { dialogOptions, snackBarOptions } from "./mat-options";
import { loaderInterceptor } from "./partials/interceptors/loader.interceptor";
import { appConfigInit } from "./app-config-init";
import { NgxMaskConfig, provideEnvironmentNgxMask } from "ngx-mask";
import { provideMomentDateAdapter } from "@angular/material-moment-adapter";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

const ADMIN_LANG_KEY = "admin-language";
const SUPPORTED_LANGS = ["en", "ru", "ua"] as const;
type SupportedLang = typeof SUPPORTED_LANGS[number];

function initialLang(): SupportedLang {
    const stored = localStorage.getItem(ADMIN_LANG_KEY)?.toLowerCase();
    if (stored && (SUPPORTED_LANGS as readonly string[]).includes(stored)) {
        return stored as SupportedLang;
    }
    return "en";
}

const maskConfig: Partial<NgxMaskConfig> = {
    validation: false,
};

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        appConfigInit,
        provideRouter(routes, withComponentInputBinding()),
        importProvidersFrom([
            MatTooltipModule,
            MatIconModule,
            MatListModule,
            MatSidenavModule,
            StoreModule.forRoot(
                {},
                {
                    runtimeChecks: {
                        strictStateImmutability: false,
                        strictActionImmutability: false,
                    },
                },
            ),
            EffectsModule.forRoot([]),
            ProfileStoreModule,
        ]),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: "./assets/i18n/",
                suffix: ".json",
                useHttpBackend: true,
            }),
            fallbackLang: "en",
            lang: initialLang(),
        }),
        provideEnvironmentNgxMask(maskConfig),
        provideHttpClient(
            withInterceptors([tokenInterceptor, authInterceptor, loaderInterceptor, errorInterceptor]),
        ),
        provideMomentDateAdapter(MY_FORMATS),
        provideAnimationsAsync(),
        snackBarOptions,
        dialogOptions,
    ],
};
